import React, { useState,useEffect } from 'react';
import ProjectCard from '../ProjectCard/ProjectCard';
import './projects.css'
import client from '../../../utils/prismicHelpers';
import * as queries from "../../../utils/prismicQueries";
import ProjectSlider from './ProjectSlider';


   const Projects = () => {
  
    const [projectDoc, setProjectData] = useState(null);
    const [projectCardInfo, setProjectCardInfo] = useState(null);
   
    useEffect(() => {
        client
            .query({
                query: queries.projectInfo,
            })
            .then((response) => {
                const projectContent = response.data.allProjects.edges[0].node;
                setProjectData(projectContent);
                setProjectCardInfo(projectContent.project_info);

            })
            .catch((error) => {
                console.error(error);
            });
    });
  
    // const testCard   =[...projectCardInfo,...projectCardInfo]
   
  
    return (
        <section className="project-container pattern" style={{ backgroundImage: `url(${projectDoc?.project_bg?.url})` }}>
            <div id="project-stepper" className="container stepper" >
                <h5 className='section-title'>{projectDoc?.title[0]?.text}</h5>
                <h3 className="subtitle">{projectDoc?.sub_title[0]?.text}</h3>
                <p className="body-text  d-none d-md-block ">{projectDoc?.description[0]?.text}</p>
                <div className="row gx-5  gy-2">
                    {<ProjectSlider projectCardInfo={projectCardInfo}/>}
                    {/* {projectCardInfo?.map(projectinfo => <ProjectCard projectinfo={projectinfo}  key={Date.now() + Math.random()}></ProjectCard>)} */}
                </div>
            </div>

        </section>
    );
};

export default Projects;